import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';

import { AuthService } from '../services/auth.service';
import { ClientsService } from '../services/clients.service';
import { Client } from '../models/client.model';
import { AddressesService } from '../services/addresses.service';
import { ShipmentsService } from '../services/shipments.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-bol2',
  templateUrl: './create-bol2.component.html',
  styleUrls: ['./create-bol2.component.css']
})
export class CreateBol2Component implements OnInit {
  user;
  clients: Client[];
  // userShort;
  client;
  displayButton: boolean;
  clientName; pickupDateSet;  pickupDate;  pickupid;  pickupContact;   pickupContacts;  pickupLocation;  newPickupContact;  pickupContactid;
  deliveryDate;  deliveryDateSet;  deliveryid;  deliveryLocation;  delivContact;  delivContacts;  newDelivContact;  delivContactid;
  pickupSelected = false;  deliverySelected = false;
  altAddresses; service; equipment; notes; equipmentSelected; services; reference;
  shipItems = [];
  shipItem = {PCS: 1, L: 45, W: 45, H: 36, wt: 250, dimwt: 250, notes: '' };
  newShipmentPost;
  selContactPu; selContactDel; contactsPu; contactsDel;
  addPickupContact = false; addDeliveryContact = false; newAddressForm = false;
  userShort; phone; clientContacts; clientContact;

  constructor(private addressesService: AddressesService,
              private clientsService: ClientsService,
              private shipmentsService: ShipmentsService,
              private router : Router,
              private authService: AuthService ) {

                this.pickupDateSet = new Date().toISOString().slice(0, 19).replace('T', ' ');
                this.pickupDate = this.pickupDateSet;
                this.setDeliveryDate();
                this.loadEquipment();
                this.loadServices();

                if (localStorage.getItem('selectedId')) {
                  const clientid = localStorage.getItem('selectedId');
                  this.clientsService.getSelectedClient(clientid)
                  .then ((client) => {
                    this.client = client[0];
                    this.getClients();
                    this.getAltAddresses(client.clientid);

                });
              } else {
                this.onNoClient();
                this.getClients()

              }

      // activate authservice to get user and client
      this.authService.getUserClientPromise2();
      // get user
      this.authService.user$.subscribe((user: any) => {
        this.user = user;
        this.userShort = user.firstname + user.lastname.slice(0, 1);
        });

      // get client
      this.authService.client$.subscribe((client) => {
        this.client = client;
        if(client.cname !== 'No Client Selected'){
        this.getAltAddresses(client.clientid);
        this.getClientContacts();
        }
      });
      }

  ngOnInit() {

  }

  onClientContactSel(contactid) {
    // accept contactid of this.clientContacts then filter and set this.clientContact
    const index = this.clientContacts.findIndex(x => x.contactid == contactid);
    this.clientContact = this.clientContacts[index]
  }

  getClientContacts() {
    // get the list of clientcontacts
    this.addressesService.getClientContacts(this.client.clientid)
    .then( (clientContacts) => {
      this.clientContacts = clientContacts;
      this.clientContact = this.clientContacts[0];
    })
  }

  // get client list

  getClients(){
    // get the client list from clients.service
    this.clientsService.getClients()
    .then(response => {
      this.clients = response; // set client list
      if(!response.message) {
        this.clients = response; // set client list
        // Look for stored selected clientid now
        if (localStorage.getItem('selectedId')) {
          const clientid = localStorage.getItem('selectedId');
          this.addressesService.getAltAddresses(clientid)
          .then (altAddresses => this.altAddresses = altAddresses )

        }

        // this.checkSelectedClient();
      }else {
        console.log(response.message)
        // TODO  create authservice logic for 403 repsone to set user BASE_USER
      }
    });
  }
  // Check sorage for a client already selected
  getClientStored() {
    if (localStorage.getItem('selectedId')) {
      const clientid = localStorage.getItem('selectedId');

    }else {
      this.onNoClient();
    }

  }

  // checkSelectedClient(){// TODO
  //   if(localStorage.getItem('selectedId')){
  //     // if clientid stored rettriev it and use
  //     const clientid = localStorage.getItem('selectedId');
  //     // find client info in clientArray
  //     const clientFiltered = this.clients.filter(function(element) {
  //       // this.addressesService.getAltAddresses(clientid);
  //       return element.clientid == clientid;
  //     })
  //     this.client = clientFiltered[0];
  //     console.log(this.client)

  //     // this.onClientSelected(clientid);
  //     this.displayButton = true;

  //   }else{
  //     this.onNoClient();
  //   }
  // }

onNoClient(){
  // case no client is selected fill in empty strings
  this.client = {cname: "No Client Selected", address: "", city: "", state: "", zip: "", qbid: "0"};
  this.displayButton = false;
}




  onClientSelected(eventValue){
    // get client info when a client is selected
    console.log(eventValue)
    this.clientsService.getSelectedClient(eventValue)
    .then(response => {
      if(!response.message) {
        const clientarray = response;
        this.client = clientarray[0]
        // set data in local storage for use by components
        localStorage.setItem('selected', this.client.cname);
        localStorage.setItem('selectedId', this.client.clientid);
        this.addressesService.getAltAddresses(this.client.clientid)
        .then((altAddresses) => {
          console.log(altAddresses)
          this.altAddresses = altAddresses;
          this.getClientContacts();

        });
      } else {
        console.log(response.message)
        // TODO  create authservice logic for 403 repsone to set user BASE_USER
      }

    });
  }

  onNewAddress() {
    // Toggle the new address form opn/close
    this.newAddressForm = this.newAddressForm ? false : true ;
    this.phone = '';
     }


  onNewAltAddress(formValue, formValid) {
    this.newAddressForm = false;
    console.log(formValue)
    // logic to post of altAddress get insertId
    this.addressesService.onAddAddress(formValue, this.client.clientid)
    .then ((result) => {
      // reload altAddresses
      this.addressesService.getAltAddresses(this.client.clientid)
      .then((altAddresses) => {
        console.log(altAddresses)
        console.log(result)
        this.altAddresses = altAddresses;

      });
    });
  }

  onPickupSelected(id1) {
    console.log(id1)
    console.log(this.altAddresses)
    if (id1 > 0) {
        // filter array to get pickup location data
      const index = this.altAddresses.findIndex(x => x.id == id1);
      console.log(index)
      this.pickupLocation = this.altAddresses[index];
      this.pickupSelected = true;
      this.pickupid = id1;
      this.getContacts( id1, 'pickup');
    }
  }

  onDestSelected(id1) {
    if (id1 > 0) {
      // filter array to get pickup location data
    const index = this.altAddresses.findIndex(x => x.id == id1);
    this.deliveryLocation = this.altAddresses[index];
    this.deliverySelected = true;
    this.deliveryid = id1;

    this.getContacts( id1, 'delivery');
  }
}


  getAltAddresses(clientid){
    if(clientid != 0){
      this.addressesService.getAltAddresses(clientid)
      .then( addresses => {
        this.altAddresses = addresses;
        // this.onPickupSelected(this.user.defaultpickupid)
      });
    }
  }

  getContacts(id, type) {
    this.addressesService.getAddressContacts(id)
    .then ( (contacts) => {
      console.log(contacts)
      if (type === 'pickup') {
        if(contacts.length === 0) {
          contacts = [{fname: 'None', lname: 'None', phone: 'xxx-xxx-xxxxx' }];
        }
        this.contactsPu = contacts;

        this.selContactPu = contacts[0];
        console.log(this.selContactPu)
      } else {
        this.contactsDel = contacts;
        this.selContactDel = contacts[0];
        console.log(this.selContactDel)
      }
    });
  }

  onPickupDateChange(date) {
    this.pickupDate = date;
  }

  onDeliveryDateChange(date) {
    this.deliveryDate = date;
  }


  setDeliveryDate() {
    const todaysDate = new Date();
    // set case logic if friday add 3 if sat add 2 if sun add 1
    if(todaysDate.getDay() === 5){
      todaysDate.setDate(todaysDate.getDate() + 3);
    }else if (todaysDate.getDay() === 6){
      todaysDate.setDate(todaysDate.getDate() + 2);
    }else {
      todaysDate.setDate(todaysDate.getDate() + 1);
    }
       this.deliveryDateSet = todaysDate.toISOString().slice(0, 19).replace('T', ' ');;
       this.deliveryDate = this.deliveryDateSet;
  }

  loadServices(){
    this.services = [{name:'Local'}, {name:'Economy'}, {name:'Next Day'}, {name:'2nd Day'}, {name:'3 Day'}, {name:'Hot Shot'},{name: 'Dedicated Truck'},]

  }

  loadEquipment(){
    this.equipment = [{name:'None'}, {name:'Lift-Gate'},  {name:'Forklift'}, {name: "Pallet Jack"}, {name: "load Bars"}, {name:'Other Put in Notes'},]
  }


  onServiceSelected(service){
    this.service = service;

  }

  onEquipmentSelected(equipment){
    this.equipmentSelected = equipment;

  }

  setShipItemDefaults() {
    this.shipItem = {PCS:1, L:45, W:45, H:36, wt:250, dimwt:250, notes:"" };

  };

  calcDimwt() {
    const dimwt = ((this.shipItem.L * this.shipItem.H * this.shipItem.W)/250)
    this.shipItem.dimwt = Math.ceil(dimwt);
  };

  onSaveShipItem() {
    const item = this.shipItem; // creates copy of item to stop editing
    this.shipItems.unshift(item);
    this.setShipItemDefaults();


  };

  onDeleteShipItem(index) {
    // remove item from shipItems array
    this.shipItems.splice(index);
  }

  onCreateBol(){
    // if the form is valid then build the post object
    this.newShipmentPost = {
      clientcontactid: this.clientContact.contactid,
      clientid: this.client.clientid,
      pudate: this.pickupDate,
      delivdate: this.deliveryDate,
      notes: this.notes,
      reference: this.reference || '',
      pickupid: this.pickupid,
      deliveryid: this.deliveryid,
      service: this.service || 'Local',
      equipment: this.equipmentSelected || 'None',
      delivcontactid: this.selContactDel.contactid || 0,
      pickupcontactid: this.selContactPu.contactid || 0,
      userid: this.user.userid || 0
      } ;
      console.log(this.newShipmentPost);


  // Logic to send newshipment request to node/db goes here
  this.shipmentsService.createNewShipment(this.newShipmentPost)
  .then(newShipment => {
      // get shipreqid back from node after success
      const bolqtid = newShipment.insertId;
      const that = this;
      console.log(bolqtid)
      // then save shipitems to node/db here for this id
        this.shipItems.forEach(function(item){
            item.bolqtid = bolqtid;
          // loops through shipItems array and enters them into tblshipitems
          that.shipmentsService.addShipItems(item)
          .then(result => {
            }) // not used
          .catch(err => console.log(err))
      });
      this.shipmentsService.addToBoard(bolqtid, that.userShort, that.user.userid)
      .then((result) => {
        alert('ADDED BOL to Board');
        that.router.navigate(['/activeshipments']);
      })
      .catch(err => console.log(err))

  })
  .catch(err => console.log(err))

    }

    onContactpuchange(id){
      console.log(id)
      // change the pu contact selected
      this.addressesService.getAddressContact(id)
      .then ((contact) => {
        this.selContactPu = contact[0];
      });

    }

    onContactDelchange(id) {
      this.addressesService.getAddressContact(id)
      .then ((contact) => {
        this.selContactDel = contact[0];
      });

    }
    onOpenAddContactD() {
      // opens add pickup cantact form
      this.addDeliveryContact = this.addDeliveryContact ? false : true;
      this.phone = '';
    }


    onOpenAddContactP() {
      // opens add pickup cantact form
      this.addPickupContact = this.addPickupContact ? false : true;
      this.phone = '';
    }

    onAddContactPu(formValue) {
      this.addPickupContact = false;
      console.log(formValue)
      const contact = {fname: formValue.fnamep, lname: formValue.lnamep, phone: formValue.phonep};
      this.addressesService.addAddressContact(contact, this.pickupid)
      .then ((result) => {
        this.selContactPu.contactId = result.insertId;
        this.selContactPu.fname = formValue.fnamep;
        this.selContactPu.lname = formValue.lnamep;
        this.selContactPu.phone = formValue.phonep;
      });
    }

      onAddContactDel(formValue) {
        this.addDeliveryContact = false;
        console.log(formValue)
        const contact = {fname: formValue.fnamed, lname: formValue.lnamed, phone: formValue.phoned};
        this.addressesService.addAddressContact(contact, this.deliveryid)
        .then ((result) => {
          this.selContactDel.contactId = result.insertId;
          this.selContactDel.fname = formValue.fnamed;
          this.selContactDel.lname = formValue.lnamed;
          this.selContactDel.phone = formValue.phoned;
        });
    }

    onPhoneFormat(value) {
      // formaT the phone number on exit
      console.log(value)
      this.formatPhoneNumber(value, (formatedPhone) => {
        console.log(formatedPhone)
        this.phone = formatedPhone;

      } );
    }

    formatPhoneNumber (str, callback) {
      // Filter only numbers from the input
      const cleaned = ('' + str).replace(/\D/g, '');
      // Check if the input is of correct length
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

      if (match) {
        callback( '(' + match[1] + ') ' + match[2] + '-' + match[3]);
      }else {
        callback(null)
      }

    }




}



// WEBPACK FOOTER //
// ./src/app/create-bol2/create-bol2.component.ts